import { render, staticRenderFns } from "./MatchLoadingStep.vue?vue&type=template&id=6c921c33"
import script from "./MatchLoadingStep.vue?vue&type=script&lang=js"
export * from "./MatchLoadingStep.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports